<template>
	<div v-if="newData.length" class="task-box">
		<div class="task-title">{{$route.query.title || ''}}</div>
		<div v-for="(k, index) in newData" :key="index + '/' + index">
			<!-- 单独 -->
			<div v-if="!k.tbody && !k.thead" class="task_f">
				<h3 class="label">{{k.label}}</h3>
				<div v-if="k.type === 'text'" class="input-box input-mt">
					<input v-model="k.value" type="text" />
				</div>
				<div v-if="k.type === 'textarea'" class="input-mt">
					<textarea v-model="k.value"></textarea>
				</div>
			</div>
			<!-- 列表 -->
			<div v-else>
				<div class="task_f">
					<h3 class="label">{{k.label}}</h3>
					<div class="table-box">
						<table :width="k.thead.length * 160">
							<thead>
								<tr>
									<td v-for="(item, iKeys) in k.thead" :key="iKeys + ''">{{ item }}</td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item1, index1) in k.tbody" :key="index1 + ''">
									<td v-for="(item2, index2) in k.tbody[index1]" :key="index2 + ' ' + index2">
										<van-cell-group class="textarea">
										  <van-field
										  	class="textarea"
										    v-model="k.tbody[index1][index2]"
										    type="textarea"
										    rows="1"
										    autosize
										  />
										</van-cell-group>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div @click="addRowData" class="add_btn"> + 追加一条记录</div>
				</div>
			</div>
		</div>
		<div class="footer-box text-center">
			<van-button @click="addFromData" round size="normal" class="btn-yellow" type="default">提交</van-button>
			<van-button @click="showProView" round size="normal" :class="[imgurl.length ? '' : 'prohibit', 'btn-yellow']" type="default">转为图片</van-button>
		</div>
		<van-popup :lock-scroll="false" class="modul-box" v-model="showModul">
			<div class="modul">
				<img :src="imgurl" alt="" />
				<h3>长按图片保存</h3>
			</div>
		</van-popup>
	</div>
</template>
<script>
	import { tablelist, subtable } from "@/api/person";
	import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {
				//
				newData: [],
				form_id: "",
				table_id: null,
				imgurl: "",
				showModul: false
			}
		},
		methods: {
			showProView(){
				if(this.imgurl){
					this.showModul = true;
				}
			},
			addRowData(){
				let key = this.table_id;
				let len = this.newData[key].thead.length;
				let createArr = this.createArrEle(len);
				this.newData[key].tbody.push(createArr);
			},
			pullData(){
				let q = this.$route.query;
				this.newData = [];
				tablelist({
					id: q.id,
					cid: q.cid
				})
				.then((data) => {
					let userTable = data.usertable;
					let dataTable = data.table;
					//
					this.imgurl = data.imgurl;
					// from_id
					this.form_id = dataTable[0].form_id;

					if(userTable.length){
						// 有数据
						for(let [index, arg] of userTable.entries()){
							// 表格
							if(dataTable[index].config && dataTable[index].config.thead){
								this.newData.push({
									"label": dataTable[index].label,
									"thead": dataTable[index].config.thead,
									"tbody": JSON.parse(userTable[index].content),
									"type": dataTable[index].type,
									"field_id": userTable[index].field_id
								})
								// table_id
								this.table_id = (this.newData.length - 1);
							// 输入组
							}else{
								this.newData.push({
									"label": dataTable[index].label,
									"value": userTable[index].content,
									"type": dataTable[index].type,
									"field_id": userTable[index].field_id
								})
							}
						}
					}else{
						// 有默认数据
						for(let [index, arg] of dataTable.entries()){
							if(arg.config && arg.config.thead){
								this.newData.push({
									"label": dataTable[index].label,
									"thead": dataTable[index].config.thead,
									"type": dataTable[index].type,
									"tbody": [this.createArrEle(dataTable[index].config.thead.length)],
									"field_id": dataTable[index].id
								})
								// table_id
								this.table_id = (this.newData.length - 1);
							}else{
								this.newData.push({
									"label": dataTable[index].label,
									"type": dataTable[index].type,
									"value": (dataTable[index].config && dataTable[index].config.default) ? dataTable[index].config.default : dataTable[index].config,
									"field_id": dataTable[index].id
								})
							}
						}
					}
					// console.log(this.newData);
				});
			},
			addFromData(){
				let q = this.$route.query
				let fieldResult = this.machiningData();
				subtable({
					"cid": q.cid,
					"form_id": this.form_id,
					"field": fieldResult
				})
				.then((data) => {
					if(data.code){
						this.$toast.fail('添加失败');
					}else{
						this.$toast.success('添加成功');
						// 啦下新数据
						this.pullData();
					}
				})

			},
			machiningData(){
				let arrData = [];
				for(let arg of this.newData){
					if(arg.thead && arg.tbody){
						arrData.push({
							"field_id": arg['field_id'],
							"content": JSON.stringify(arg.tbody)
						})
					}else{
						arrData.push({
							"field_id": arg['field_id'],
							"content": arg['value']
						})
					}
				}
				// console.log(arrData);
				return JSON.stringify(arrData);
			},
			createArrEle(len){
				let arr = [];
				for(var i=0; i<len; i++){
					arr.push("");
				}
				return arr
			},
			setTitle(){
				document.title = this.$route.query.title;
			}
		},
		created(){
			this.pullData();
			this.setTitle();
			shareCon("index",this);
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/taskStyle.scss";
	.footer-box{
		margin-top: 20px;
		.btn-yellow{
			background: #EB5032;
			color: #fff;
			margin: 0 10px;
			height: 60px;
			line-height: 60px;
			padding: 0 40px;
		}
		.prohibit{
			background: #cccccc;
		}
	}
	.table-box{
		margin-top: 20px;
		overflow: auto;
		-webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
		background: #fff;
		padding-bottom: 1px;
		padding-right: 1px;
		table{
			border-collapse:collapse;
		}
		td{
			border: 1px solid #EB5032;
			text-align: center;
			padding: 10px 0;
			overflow: hidden;
			width: 160px;
		}
		tbody{
			td{
				padding: 0;
			}
		}
		.textarea{
			&:after{
				border-color: #fff;
			}
		}
	}
	.add_btn{
		margin-top: 20px;
		border: 1px solid #EB5032;
		height: 60px;
		line-height: 60px;
		text-align: center;
		background: #EB5032;
		border-radius: 30px;
		color: #fff;
	}
	.modul-box{
		background: rgba(255,255,255,0);
	}
	.modul{
		overflow: auto;
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
		h3{
			text-align: center;
			color: #fff;
			line-height: 80px;
		}
		img{
			max-width: 8rem;
		}
	}
</style>
<style>
	.textarea textarea{
		font-size: 30px;
	}
</style>